import { faArrowRightLong } from '@fortawesome/pro-regular-svg-icons';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { lineLight, backgroundColored, fontDark } from '@constants/colors';
import { book } from '@constants/routes';
import { space } from '@constants/spaces';
import Button from '@elements/Button';
import Text from '@elements/Text';
import useMediaQuery from '@hooks/useMediaQuery';

const Component = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${space * 2}px ${space * 4}px;
  background-color: ${backgroundColored};
  border-top: 1px solid ${lineLight};
  z-index: 13000;
  color: ${fontDark};
  gap: ${space * 2}px;
`;

type ProductFixedBarProps = {
  bookID: string;
};

const ProductFixedBar = ({ bookID }: ProductFixedBarProps) => {
  const [showProductFixedBar, setShowProductFixedBar] = useState(true);
  const { isTablet } = useMediaQuery();

  useEffect(() => {
    // Hide after 70% page scroll
    const handleScroll = () => {
      const pageHeight = document.documentElement.scrollHeight;
      const eightyPercentHeight = 0.7 * pageHeight;

      if (window.scrollY >= eightyPercentHeight) {
        setShowProductFixedBar(false);
      } else {
        setShowProductFixedBar(true);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  if (!isTablet || !showProductFixedBar) return null;

  return (
    <Component>
      <Link href={book(bookID, '')}>
        <a>
          <Button iconRight={faArrowRightLong}>Begin nu</Button>
        </a>
      </Link>
      <Text size="nm" weight={500}>
        Vanaf &euro; 27,50
      </Text>
    </Component>
  );
};

export default ProductFixedBar;
